import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;

/**
 * Recupera El token de acceso inicial 
 * @returns {Array}  - Arreglo que devuelve datos de token de inicio
 * @author alSanchez - ETE
 * @version 1.0.0 - Septiembre 2021
 * */ 
const getInitToken = () => {

    const credentials = JSON.stringify({
        noCustomer: process.env.REACT_APP_USERNAME_INIT, 
        password: process.env.REACT_APP_PASSWORD_INIT
    })
    
    const url = `${ baseUrl }/auth/login/front`;
return axios.post(url, credentials,
{headers: {
    'Content-Type': 'application/json'
  }}).then(
    (response) => {
        localStorage.setItem('initToken', response.data.token);
    return response.data;
})
};

/**
 * Recupera El token de acceso inicial 
 * @returns {Array}  - Arreglo que devuelve usuario con token de refresh
 * @author alSanchez - ETE
 * @version 1.0.0 - Septiembre 2021
 * */ 
const getRefreshToken = () => {

    const url = `${ baseUrl }/refreshToken`;
    const user = JSON.parse(localStorage.getItem('client'));
    
    return axios.get(url,
        {
            headers: {
              Authorization: 'Bearer ' + user.token
            }
          }
    ).then(
        (response) => {
            localStorage.setItem('client', JSON.stringify(response.data));
            localStorage.setItem("timeSesion", new Date());
        
            return response.data;
            })
  };

export default {
    getInitToken,
    getRefreshToken
};